module.exports = __webpack_public_path__ + "static/media/suit.790ce2ba.png";